module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	require('jquery-scrollspy/jquery-scrollspy');

	require('owl-carousel2/dist/owl.carousel.min');
	require('owl-carousel2/dist/assets/owl.carousel.min.css');
	
	fox.registerWidget('Promo_Home', {
		configure: function(options) {
			this.registerOptions('', {
				template: 'promo_home_page',
				config: {
					owlClass: 'owl-carousel owl-theme',
					blockWatchClass: '.block-watch',
					blockWatchURLClass: '.block-watch-url',
					carousels: {
						features: {
							id: '#features-carousel',
							responsive:{
								320:{
									items:1
								},
								768:{
									items:2,
									slideBy: 2
								},
								1150:{
									items:3
								}
							},
							limitWindowWith: 1150
						},
						promotools: {
							id: '#promotools-carousel',
							responsive:{
								320:{
									items:1
								},
								768:{
									items:2,
									slideBy: 2
								},
								1150:{
									items:3
								}
							},
							limitWindowWith: 1150
						},
						
						sites: {
							id: '#home-carousel',
							margin:0,
							autoplay: true,
							autoplayTimeout:5000,
							autoplaySpeed: 1000,
							/*animateOut: 'fadeOut',*/
							responsive:{
								320:{
									items:1,
									loop:true,
									autoplay:true
								}
							}
						}
					}
				},
				carouselsIsInit: {},
				params: {},
				widgets: {
					subscribeForm: {
						widget: 'Form',
						formContainer: '#subscribe-form',
						formElements: {
							name: {
								element: '[name="name"]',
								defaultValue: ''
							},
							email: {
								element: '[name="email"]',
								defaultValue: '',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
							},
							type: {
								element: '[name="group"]',
								defaultValue: 'mcprofits-subscriber'
							}
						},
						methods: {
							send: 'subscription.subscribe'
						},
						submit: {
							target: '#subscribe-form',
							event: 'submit'
						},
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['name', 'email'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Please fill in required fields'
							}]
						},
						hooks: {
							onResponse: '@parent:subscribeFormIsSubmitted',
							onSubmit: '@parent:subscribeFormSubmit'
						},
						handleWom: {
							formError: {
								event: 'formNotValid',
								widget: '@this #validator',
								callback: '@parent:subscribeFormNotValid'
							}
						}
					},
					signupForm: {
						widget: 'Home_Registration'
					},
					warningPopup: {
						widget: 'Dialog',
						template: 'same_account',
						dialog: {
							autoOpen: options.autoOpen || false,
							dialogClass: 'dlg-amc dark-overlay',
							title: 'ERROR',
							closeText: '',
							width: 'auto'
						},
						handleWom: {
							dOnShow: {
								event: 'show',
								widget: '@this',
								'params.prefix': 'uniqPopEvent',
								callback: function () {
									$(fox.dom.selectFirst('.wrapper')).addClass('blured');
								}
							},
							dOnHide: {
								event: 'hide',
								widget: '@this',
								'params.prefix': 'uniqPopEvent',
								callback: function () {
									$(fox.dom.selectFirst('.wrapper')).removeClass('blured');
								}
							}
						}
					},

					sitesDatalayer: {
						widget: 'Datalayer',
						method: 'Partner_McProfits.getModels',
						fields: ['mcpSubscription._avatar', 'site.domain', 'clientId.name', 'aboutMe._avatarPath', 'fcProfile.alias'],
						/*filter: {
							project: {
								fields: ['mcpSubscription.project'],
								values: [1]
							}
						},*/
						metaFields: {
							'totalCount': 1,
							'mcpSubscription.avatar': 1,
							'aboutMe.avatarPath': 1
						},
						limit: 4,
						handleWom: {
							loaded: {
								widget: '@this',
								event: 'loaded',
								callback: function(){
									var lastSite = this.getCollection()[0];
									var totalCount = this.getMetaValue('totalCount');
									this.wom1("@parent #lastSiteAdded").setCollection([lastSite], true);

									this.getParent().renderCounter(totalCount);

								}
							}
						}
					},

					filter: {
						widget: 'AdvancedFilter_ModelsFilter',
						template: 'models_advanced_filter',
						'!embed.container': '.filter-models'
					},
					
					lastSiteAdded: {
						widget: 'List',
						container: '.last-model-site',
						'tpl.row': 'last_model_site'
					},

					siteCounter: {
						widget: 'Widget',
						container: '.counter',
						template: 'counter_item',
						templateThousand: 'counter_thousand_item',

						handleWom: {
							addedToDom: {
								widget: '@this',
								event: 'addedToDom',
								callback: function() {
									var dl = this.wom1('@parent #sitesDatalayer');
									var lastSite = dl.getCollection()[0];
									var totalCount = dl.getMetaValue('totalCount');
									this.getParent().renderCounter(totalCount);
								}
							}
						}
					},

					ourSites:{
						widget: 'Grid',
						dl: '@parent #sitesDatalayer',
						container: '.list-models',
						list: {
							'tpl.row': 'our_sites_model',
						},
					}
				},
				handleWom: {
					scrolling: {
						widget: '@root #windowScrollHandler',
						event: 'topPointReached',
						callback: 'changeHeaderColor'
					},
					addedToDom: {
						widget: '@this',
						event: 'addedToDom',
						callback: 'prepareElements'
					},
					'!pageAddedToDom': {
						event: 'addedToDom',
						widget: '@this',
						callback: function () {}
					}
				},
				handleDom: {
					scrollDown: {
						target: '.scroll-down-icon',
						event: 'click',
						callback: 'scrollTo'
					},
					menuHeaderClick: {
						target: '.menu-link',
						targetWidget: '@parent @parent #header',
						event: 'click',
						callback: 'scrollTo'
					},
					logoClick: {
						target: '#mcprofits-logo',
						targetWidget: '@parent @parent #header',
						event: 'click',
						callback: 'scrollTo'
					},
					menuFooterClick: {
						target: '.menu-link',
						targetWidget: '@parent @parent #footer',
						event: 'click',
						callback: 'scrollTo'
					},
					gradeClick: {
						target: 'label.btn',
						event: 'click',
						targetWidget: '#filter',
						callback: 'checkboxGroup'
					},
					regDown: {
						target: '.features_signup .scroll-down-icon',
						event: 'click',
						callback: 'scrollTo'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.startResizeWatcher();
			this.callParent('init', arguments);
		},

		deactivate: function() {
			this.destroyBlocksFollow();
			this.resetStateMenus();
			this.callParent('deactivate', arguments);
		},

		activate: function() {
			this.initBlocksFollow();
			this.callParent('activate', arguments);
		},

		prepareElements: function() {
			var menustate = fox.Navigator.get(0);
			if (menustate !== 'home'){
				this.scrollTo(menustate);
			}
			this.stateHeaderBg();
			this.updateCarousels();
			this.calculateElements();
			this.initBlocksFollow();
			fox.wom.selectFirst("@root #windowScrollHandler").enable();
			this.findSectionNameInURL();
		},

		startResizeWatcher: function() {
			$(window).on('resize.homepage', fox.bind(function(e){
				clearTimeout(this.timer);
				this.timer = setTimeout(fox.bind(function() {
					this.updateCarousels();
					this.calculateElements();
					this.reinitBlocksFollow();
				}, this), 1000);
			}, this));
		},

		stateHeaderBg: function() {
			$('#promo-header').toggleClass('header-bg', $('#promo-header').offset().top > 0);
		},

		findSectionNameInURL: function() {
			var section = fox.Navigator.get(1);

			if (section) {
				this.scrollTo(section);
			}
		},

		needInitCarousel: function(name) {
			var limit = this.getOption('config.carousels.' + name + '.limitWindowWith');

			return !limit ? true : window.innerWidth < this.getOption('config.carousels.' + name + '.limitWindowWith');
		},

		calculateElements: function() {
			this.setOption('params.header_h', $('#promo-header').height());

			if (window.innerWidth < 768) {
				this.setOption('params.header_h', 65);
			}
		},

		updateCarousels: function() {
			var data = this.getOption('config.carousels');

			fox.each(data, function(data, name){
				if (this.needInitCarousel(name)) {
					this.initCarousel(data, name);
				} else if (!this.needInitCarousel(name)) {
					this.destroyCarousel(data, name);
				}
			}, this);
		},

		initCarousel: function(data, name) {
			var carousel = this.dom1(data.id),
				owl = $(carousel);
				//dataForCarousel = {};

			fox.dom.addClass(this.getOption('config.owlClass'), carousel);

			/*if (data.responsive) {
				dataForCarousel.responsive = data.responsive || {};
			}

			if (data.onDragged) {
				dataForCarousel.onDragged = data.onDragged;
			}*/

			owl.owlCarousel(data);
		},

		destroyCarousel: function(data, name) {
			var carousel = this.dom1(data.id);
			var owl = $(carousel);

			owl.trigger('destroy.owl.carousel');

			fox.dom.removeClass(this.getOption('config.owlClass'), carousel);

			
		},

		initBlocksFollow: function() {
			var blocks = $(this.getOption('config.blockWatchClass'));
			var header_h = this.getOption('params.header_h');
			var self = this;

			blocks.each(function(i) {
				var position = $(this).position();
				if(position.top === 0) {self.switchStateMenu('home', true);}
				$(this).scrollspy({
					min: (position.top < header_h) ? 0 : position.top - header_h,
					max: position.top + $(this).height() / 1.5,
					onEnter: function(element, position) {
						if (!self.getOption('params.scrillingIsActive')) {
							var nameMenu = element.getAttribute('data-name');
							self.switchStateMenu(nameMenu, true);
							self.switchHashURL(nameMenu);
						}
					},
					onLeave: function(element, position) {
						self.switchStateMenu(element.getAttribute('data-name'), false);
					}
				});
			});
		},

		reinitBlocksFollow: function() {
			$(window).off('scroll.scrollspy');
			this.initBlocksFollow();
		},

		destroyBlocksFollow: function() {
			$(window).off('scroll.scrollspy');
		},

		switchStateMenu: function(name, type) {
			$('#promo-header .menu-link').removeClass('active');
			$('#promo-header .menu-link[data-name="' + name + '"]').toggleClass('active', type);
		},

		resetStateMenus: function() {
			$('#promo-header .menu-link').removeClass('active');
		},

		switchHashURL: function(name) {
			name = (name === 'home') ? '' : name;
			if (history.pushState) {
				history.pushState(null, null, '/' + name);
			} else {
				fox.Navigator.update({0: '/' + name}, true);
			}
		},

		refreshBlocksFollow: function() {
			var blocks = $(this.getOption('config.blockWatchClass'));
		},

		scrollTo: function(elm) {
			if (elm === undefined) {
				return;
			}

			var target, nameMenu,
				header_h = this.getOption('params.header_h'),
				self = this;

			nameMenu = (typeof elm === "object") ? elm.getAttribute('data-name') : elm;
			target = $('section[data-name="' + nameMenu + '"]');

			if (target.length) {
				this.stateScrilling(true);
				$('html,body').animate({
					scrollTop: target.offset().top - header_h
				}, 1000)
				.promise()
				.done(function(){
					self.stateScrilling(false);
					self.switchStateMenu(nameMenu, true);
				})
				.fail(function(){
					self.stateScrilling(false);
					self.switchStateMenu(nameMenu, true);
				});
			}
		},

		changeHeaderColor: function(param) {
			$('#promo-header').toggleClass('header-bg', param.direction === 1 ? true : false);
		},

		stateScrilling: function(flag) {
			this.setOption('params.scrillingIsActive', !!flag);
		},

		subscribeFormNotValid: function(res) {
			var througthNotifications = fox.wom.selectFirst('~#throughNotifications');

			througthNotifications.pushNotification({
				noticeTemplate: 'new_notice',
				noticeType: 'error',
				noticeMessage: res.msg,
				noticeAlias: 'subscribeFieldNotValid',
				listenWidgetDeactivate: this,
				delayClose: 3000
			});
		},

		subscribeFormSubmit: function() {
			var form = this.wom1('#subscribeForm');
			form.submit();
			form.ignoreSubmit(true);
		},

		subscribeFormIsSubmitted: function(response, type) {
			var form = this.wom1('#subscribeForm');
			
			if (response.answer.answer.status) {
				var througthNotifications = fox.wom.selectFirst('~#throughNotifications');

				througthNotifications.pushNotification({
					noticeTemplate: 'new_notice',
					noticeType: 'success',
					noticeMessage: 'You have successfully subscribed to the Newsletter!',
					noticeAlias: 'subscribeSuccess',
					listenWidgetDeactivate: this,
					delayClose: 3000
				});

				form.resetForm();
			}

			form.ignoreSubmit(false);
		},

		renderCounter: function(totalCount) {
			if (!totalCount) return false;

			var counter = this.wom1('#siteCounter');
			var digits = String(totalCount).split('');
			var counterFragment = document.createDocumentFragment();
			
			if (digits.length < 4) {
				digits.unshift('0');
			}
			
			for (var i = 0; i < digits.length; i++) {
				var template = ((i + 1) % 4 === 0) ? 'counter_thousand_item' : 'counter_item';
				var rowFragment = counter.getTemplater(template).setData([{digit: digits[i]}]).compile();
				counterFragment.appendChild(rowFragment);
			}

			var container =  fox.dom.selectFirst(counter.options.container);
			container.innerHTML = '';
			container.appendChild(counterFragment);
		},

		checkboxGroup: function(el) {
			var elem = $(el).prev();
			var currentCheck = $(elem).prop("checked");
			var group = "input:checkbox[name='mcpSubscription_data_restrictionTagId']";
			$(group).prop("checked",false);
			$(elem).prop("checked", currentCheck);
		}
	}, 'Widget');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/home/home.js
// module id = 203
// module chunks = 5